import PlayList from './playList.vue'

export default PlayList
